const css = `.responsive-table.disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: default;
}
.responsive-table .p-card-content {
  padding: 0;
  overflow: auto;
}
.responsive-table > .p-card-header {
  border: 1px solid var(--border);
  border-bottom: unset;
  padding: 12px;
  margin-bottom: 0 !important;
  background: var(--surface-ground);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
}
.responsive-table > .p-card-header .header-left {
  display: flex;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
}
.responsive-table > .p-card-header .header-left .p-component .p-inputtext {
  padding: 8px;
}
.responsive-table > .p-card-header .header-right {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
}
.responsive-table .p-card-body {
  border: 1px solid var(--border);
}
.responsive-table tr.empty-row {
  pointer-events: none;
  cursor: default;
  height: 80px;
}
.responsive-table tr.empty-row td.empty-cell span:not(.cell-header) {
  visibility: hidden;
}
.responsive-table tr.empty-row td.option span {
  visibility: hidden;
}
@media (max-width: 768px) {
  .responsive-table tr.empty-row {
    display: none;
  }
}
@media (min-width: 769px) {
  .responsive-table tbody tr {
    height: 80px;
  }
  .responsive-table td.string {
    min-width: 120px;
  }
  .responsive-table td.string::after {
    content: attr(data-fit);
    display: block;
    height: 0;
    max-width: 240px;
    visibility: hidden;
    white-space: nowrap;
    overflow: hidden;
  }
  .responsive-table td.string.title-cell {
    min-width: 260px;
  }
  .responsive-table td.string.title-cell::after {
    max-width: 360px;
    overflow-wrap: anywhere;
    white-space: normal;
  }
  .responsive-table :where(td.string) > .string-value {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    contain: inline-size;
  }
  .responsive-table :where(td.string) > .cell-header-text {
    flex-wrap: wrap;
    white-space: normal;
    overflow-wrap: anywhere;
    contain: inline-size;
  }
  @supports not (contain: inline-size) {
    .responsive-table :where(td.string) > .string-value {
      max-width: 240px;
    }
    .responsive-table :where(td.string.title-cell) > .cell-header-text {
      max-width: 360px;
    }
  }
}
.responsive-table .table-scroll[aria-busy=true] tbody {
  opacity: 0.6;
  transition: opacity 0.2s;
  pointer-events: none;
}
.responsive-table table {
  font-family: var(--font-family-base);
  border-collapse: collapse;
  width: 100%;
  background: var(--surface-card);
}
.responsive-table table thead {
  background: var(--surface-ground);
}
.responsive-table table thead tr th {
  padding: 12px;
  font-weight: var(--font-weight-semibold);
  text-align: left;
  border-bottom: 1px solid var(--border);
}
.responsive-table table thead tr th .table-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.responsive-table table thead tr th .table-header > .form-field {
  gap: 0;
}
.responsive-table table thead tr th .table-header > .form-field:has(.form-field) .header-label-container {
  width: 100%;
  justify-content: space-between;
}
.responsive-table table thead tr th .table-header .header-label-container {
  color: var(--text-color);
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-color);
  font-weight: var(--font-weight-semibold);
  padding: 4px 0;
}
.responsive-table table thead tr th .table-header .header-label-container span {
  flex: 1;
}
.responsive-table table thead tr th .table-header .header-label-container label {
  display: inline;
  color: inherit;
}
.responsive-table table thead tr th .table-header .header-label-container .sort-icon {
  cursor: pointer;
  transition: all 0.2s;
  font-size: var(--font-size-sm);
  color: var(--text-color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.responsive-table table thead tr th .table-header .header-label-container .sort-icon.pi-sort-amount-up-alt, .responsive-table table thead tr th .table-header .header-label-container .sort-icon.pi-sort-amount-down {
  color: var(--accent);
}
.responsive-table table thead tr th .table-header .header-label-container .sort-icon:hover {
  color: var(--accent);
}
.responsive-table table thead tr th .table-header .p-inputtext,
.responsive-table table thead tr th .table-header .p-multiselect,
.responsive-table table thead tr th .table-header .p-calendar,
.responsive-table table thead tr th .table-header .numeric-filter {
  width: 100%;
  font-size: var(--font-size-sm);
}
.responsive-table table thead tr th .table-header .p-inputtext.p-inputtext,
.responsive-table table thead tr th .table-header .p-multiselect.p-inputtext,
.responsive-table table thead tr th .table-header .p-calendar.p-inputtext,
.responsive-table table thead tr th .table-header .numeric-filter.p-inputtext {
  padding: var(--space-2);
}
.responsive-table table thead tr th .table-header .p-inputtext.p-multiselect .p-multiselect-label,
.responsive-table table thead tr th .table-header .p-multiselect.p-multiselect .p-multiselect-label,
.responsive-table table thead tr th .table-header .p-calendar.p-multiselect .p-multiselect-label,
.responsive-table table thead tr th .table-header .numeric-filter.p-multiselect .p-multiselect-label {
  padding: var(--space-2) var(--space-3);
}
.responsive-table table thead tr th .table-header .p-inputtext.p-multiselect .p-multiselect-token,
.responsive-table table thead tr th .table-header .p-multiselect.p-multiselect .p-multiselect-token,
.responsive-table table thead tr th .table-header .p-calendar.p-multiselect .p-multiselect-token,
.responsive-table table thead tr th .table-header .numeric-filter.p-multiselect .p-multiselect-token {
  padding: 2px 8px;
  margin: 2px;
  background-color: var(--accent-chip);
  border: 1px solid var(--accent-chip-border);
  color: var(--accent);
}
.responsive-table table thead tr th .table-header .p-calendar .p-inputtext {
  min-width: 80px;
}
.responsive-table table thead tr th .table-header .numeric-filter {
  display: flex;
  gap: 8px;
}
.responsive-table table thead tr th .table-header .numeric-filter .mode-dropdown {
  width: auto;
  min-width: 64px;
}
.responsive-table table thead tr th .table-header .numeric-filter .mode-dropdown .p-dropdown-label {
  padding: var(--space-2) var(--space-3);
}
.responsive-table table thead tr th .table-header .numeric-filter .value-input {
  flex: 1;
}
.responsive-table table thead tr th .table-header .numeric-filter .value-input input {
  padding: var(--space-2) var(--space-3);
  width: 100%;
}
.responsive-table tbody tr {
  transition: background-color 0.2s;
}
.responsive-table tbody tr:hover {
  background: var(--surface-hover);
  cursor: pointer;
}
.responsive-table tbody tr td {
  padding: 12px;
  border-bottom: 1px solid var(--border);
}
.responsive-table tbody tr td.empty-state .empty-state-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--text-color-secondary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xs);
  min-height: 300px;
  flex-wrap: wrap;
  align-content: center;
}
.responsive-table tbody tr td.empty-state .empty-state-content .p-button.p-button-text {
  width: auto;
  padding: 0.25rem 0.5rem;
}
.responsive-table tbody tr td.option {
  width: 48px;
  text-align: center;
}
.responsive-table tbody tr td .p-button.p-button-text {
  padding: 0;
  width: 32px;
  height: 32px;
}
.responsive-table tbody tr td .p-button.p-button-text:hover {
  background: var(--surface-hover);
}
.responsive-table .cell-header {
  display: none;
  color: var(--text-color-secondary);
  font-weight: var(--font-weight-semibold);
  margin-bottom: 4px;
}
.responsive-table .option-button-desktop {
  display: flex;
}
.responsive-table .option-button-mobile {
  display: none;
}
.responsive-table .header-right-mobile {
  display: none;
}
.responsive-table th:not(.option),
.responsive-table td:not(.option) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.responsive-table th:not(.option) .cell-skeleton,
.responsive-table td:not(.option) .cell-skeleton {
  margin: 8px 0;
  min-width: 100px;
}
.responsive-table th:not(.option) .cell-skeleton.skeleton-avatar,
.responsive-table td:not(.option) .cell-skeleton.skeleton-avatar {
  margin: 2px 0;
  min-width: 48px;
}
.responsive-table th:not(.option).avatar,
.responsive-table td:not(.option).avatar {
  width: 80px;
}
.responsive-table th:not(.option).avatar .p-avatar,
.responsive-table td:not(.option).avatar .p-avatar {
  background: var(--surface-ground);
}
.responsive-table th:not(.option).string .cell-header-text,
.responsive-table td:not(.option).string .cell-header-text {
  display: flex;
  align-items: center;
  gap: 4px;
}
.responsive-table th:not(.option).number,
.responsive-table td:not(.option).number {
  width: 160px;
}
.responsive-table th:not(.option).number.warning, .responsive-table th:not(.option).number.error,
.responsive-table td:not(.option).number.warning,
.responsive-table td:not(.option).number.error {
  font-weight: var(--font-weight-medium);
}
.responsive-table th:not(.option).number.success,
.responsive-table td:not(.option).number.success {
  color: var(--success);
}
.responsive-table th:not(.option).number.warning,
.responsive-table td:not(.option).number.warning {
  color: var(--warning);
}
.responsive-table th:not(.option).number.error,
.responsive-table td:not(.option).number.error {
  color: var(--danger);
}
.responsive-table th:not(.option).number .number-cell-value,
.responsive-table td:not(.option).number .number-cell-value {
  display: flex;
  align-items: center;
  gap: 4px;
}
.responsive-table th:not(.option).number .number-cell-value i,
.responsive-table td:not(.option).number .number-cell-value i {
  font-weight: var(--font-weight-semibold);
}
.responsive-table th:not(.option).tag,
.responsive-table td:not(.option).tag {
  width: 180px;
}
.responsive-table th:not(.option).tag .p-multiselect-label,
.responsive-table td:not(.option).tag .p-multiselect-label {
  display: flex;
  gap: 4px;
}
.responsive-table th:not(.option).calendar,
.responsive-table td:not(.option).calendar {
  width: 192px;
}
.responsive-table th:not(.option).boolean,
.responsive-table td:not(.option).boolean {
  width: 100px;
}
.responsive-table th:not(.option).progress,
.responsive-table td:not(.option).progress {
  width: 180px;
}
.responsive-table th:not(.option).progress .progress-container,
.responsive-table td:not(.option).progress .progress-container {
  max-width: 120px;
  width: 100%;
}
.responsive-table th:not(.option).dropdown,
.responsive-table td:not(.option).dropdown {
  max-width: 240px;
}
.responsive-table th:not(.option).dropdown ul,
.responsive-table td:not(.option).dropdown ul {
  margin: 0;
}
.responsive-table th:not(.option).dropdown ul .list-item.no-decorated,
.responsive-table td:not(.option).dropdown ul .list-item.no-decorated {
  list-style: none;
  padding-left: 0;
}
.responsive-table th:not(.option) .override-message,
.responsive-table td:not(.option) .override-message {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}
.responsive-table th:not(.option) .override-message i,
.responsive-table td:not(.option) .override-message i {
  font-weight: var(--font-weight-bold);
}
.responsive-table th:not(.option) .override-message.error,
.responsive-table td:not(.option) .override-message.error {
  color: var(--danger);
  font-weight: var(--font-weight-bold);
}
.responsive-table th:not(.option) .override-message.warning,
.responsive-table td:not(.option) .override-message.warning {
  color: var(--warning);
}
.responsive-table th:not(.option) .override-message.success,
.responsive-table td:not(.option) .override-message.success {
  color: var(--success);
}
.responsive-table th:not(.option) {
  overflow: unset !important;
}
.responsive-table .p-paginator {
  container-name: paginator;
  container-type: inline-size;
  padding: 12px;
  border: unset;
  box-shadow: unset;
  background: var(--surface-ground);
  border-radius: 0;
}
.responsive-table .p-paginator .p-link svg {
  height: 14px;
}
.responsive-table .p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 36px;
  height: 36px;
}
.responsive-table .p-paginator small {
  font-size: var(--font-size-xs);
}
.responsive-table .p-paginator .paginator-responsive-separator {
  display: none;
}
.responsive-table .p-paginator .current-page-report {
  margin-right: auto;
}
.responsive-table .p-paginator .rows-per-page-dropdown {
  width: fit-content;
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}
.responsive-table .p-paginator .rows-per-page-dropdown .p-dropdown {
  height: unset;
  min-width: 64px;
}
.responsive-table .p-paginator .rows-per-page-dropdown .p-dropdown .p-dropdown-label {
  padding: 4px 0 4px 8px;
  font-size: var(--font-size-sm);
}
.responsive-table .p-paginator .rows-per-page-dropdown .p-dropdown .p-dropdown-trigger {
  width: min-content;
  padding: 0 8px 0 8px;
}
.responsive-table .p-multiselect {
  padding: 0 !important;
}
.responsive-table .progress-filter {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 33px;
}
.responsive-table .progress-filter .progress-filter-values {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  color: var(--text-muted);
}
.responsive-table .progress-filter .progress-filter-values small {
  font-size: var(--font-size-xs);
}
.responsive-table .progress-filter .progress-filter-values.inactive {
  opacity: 0.4;
}
.responsive-table .p-multiselect-item .p-tag {
  margin: 0;
}

.filters-sidebar .p-sidebar-content {
  padding: 16px;
}
.filters-sidebar .filters-sidebar-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.filters-sidebar .filters-sidebar-container .header-label-container {
  width: 100%;
}
.filters-sidebar .filters-sidebar-container .header-label-container label {
  display: inline;
}
.filters-sidebar .filters-sidebar-container .p-inputnumber {
  width: 100%;
}
.filters-sidebar .filters-sidebar-container .progress-filter-values {
  display: flex;
  justify-content: space-between;
}
.filters-sidebar .apply-filters {
  padding: 16px;
  display: flex;
  gap: 16px;
  margin-top: auto;
}
.filters-sidebar .apply-filters .p-button {
  flex: 1;
}

.paginator-page-size-menu {
  font-size: var(--font-size-sm);
}

@container paginator (max-width: 560px) {
  .p-paginator .current-page-report {
    order: 2;
  }
  .p-paginator .rows-per-page-dropdown {
    order: 3;
  }
  .p-paginator .paginator-responsive-separator {
    display: block !important;
    width: 100%;
  }
}
.boolean-value {
  display: flex;
  align-items: center;
  gap: 8px;
}
.boolean-value.true .pi {
  color: var(--success);
}
.boolean-value.false .pi {
  color: var(--danger);
}
.boolean-value.na .pi {
  color: var(--text-color-secondary);
}
.boolean-value .boolean-text {
  color: var(--text-color);
}

@media (min-width: 769px) {
  .responsive-table.p-card {
    padding: 0;
  }
  .responsive-table > .p-card-header {
    border: 0;
    border-radius: calc(var(--radius-lg) - 1px) calc(var(--radius-lg) - 1px) 0 0;
  }
  .responsive-table > .p-card-body {
    border: 0;
  }
  .responsive-table > .p-card-header + .p-card-body {
    border-top: 1px solid var(--border);
  }
  .responsive-table .p-paginator,
  .responsive-table .table-scroll:last-child {
    border-radius: 0 0 calc(var(--radius-lg) - 1px) calc(var(--radius-lg) - 1px);
  }
  .responsive-table .table-scroll-frame::before {
    border-bottom-left-radius: calc(var(--radius-lg) - 1px);
  }
  .responsive-table .table-scroll-frame::after {
    border-bottom-right-radius: calc(var(--radius-lg) - 1px);
  }
}
@media screen and (max-width: 768px) {
  th:not(.option).string .cell-header-text,
  td:not(.option).string .cell-header-text {
    text-wrap: wrap;
  }
  .responsive-table {
    padding: 0 !important;
    box-shadow: unset !important;
  }
  .responsive-table .p-card {
    margin: 0;
    border-radius: 0;
  }
  .responsive-table .p-card-header {
    padding: 12px;
    border-radius: 0;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
  }
  .responsive-table .p-card-header .header-right {
    display: none;
  }
  .responsive-table .p-card-body {
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }
  .responsive-table .filters-sidebar {
    display: block;
  }
  .responsive-table .header-right-mobile {
    display: flex;
    gap: 8px;
  }
  .responsive-table thead {
    display: none;
  }
  .responsive-table tbody {
    display: flex;
    flex-direction: column;
    max-width: 100%;
  }
  .responsive-table tbody tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--border);
    background: var(--surface-card);
    position: relative;
    padding: 8px;
    width: 100%;
  }
  .responsive-table tbody tr td {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 8px;
    border: none;
    min-height: 32px;
    gap: 8px;
    width: 100% !important;
    max-width: 100% !important;
  }
  .responsive-table tbody tr td > span {
    white-space: wrap;
  }
  .responsive-table tbody tr td > span.cell-header {
    text-align: left;
  }
  .responsive-table tbody tr td > span.string-value, .responsive-table tbody tr td > span.cell-header-text {
    text-align: right;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .responsive-table tbody tr td > ul .list-item {
    text-align: right;
  }
  .responsive-table tbody tr td.option {
    position: absolute;
    top: 4px;
    right: 4px;
    padding: 0;
    border: none;
    width: auto;
    min-height: auto;
  }
  .responsive-table tbody tr td.option .option-button-desktop {
    display: none;
  }
  .responsive-table tbody tr td.option .option-button-mobile {
    display: flex;
    margin: 8px 8px 8px auto;
  }
  .responsive-table tbody tr td .cell-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: var(--font-size-sm);
    color: var(--text-color-secondary);
    margin: 0;
  }
  .responsive-table tbody tr td.avatar {
    justify-content: center;
    flex-direction: column;
    gap: 8px;
  }
  .responsive-table tbody tr td.avatar .cell-header {
    text-align: center;
  }
  .responsive-table tbody tr td.title-cell {
    justify-content: flex-start;
    padding-right: 48px;
  }
  .responsive-table tbody tr td.title-cell .cell-header {
    display: none;
  }
  .responsive-table tbody tr td.title-cell > span.cell-header-text {
    text-align: left;
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-base);
  }
  .responsive-table tbody tr td:not(.avatar):not(.option):not(:last-child) {
    margin-bottom: 4px;
  }
  .filters-sidebar .filters-sidebar-title {
    margin: 0;
    padding: 16px 0 0 16px;
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-semibold);
  }
  .filters-sidebar .apply-filters {
    position: sticky;
    bottom: -16px;
    z-index: 1;
    background: var(--surface);
    margin: auto -16px -16px;
  }
}
@media screen and (max-width: 480px) {
  .responsive-table .p-paginator .p-paginator-pages .p-paginator-page.p-link {
    min-width: 32px;
    height: 32px;
  }
}
.sort-sidebar .p-sidebar-content {
  padding: 16px;
}
.sort-sidebar .sort-sidebar-header {
  margin-bottom: 16px;
}
.sort-sidebar .sort-sidebar-header h3 {
  margin: 0;
  color: var(--text-color);
}
.sort-sidebar .sort-sidebar-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sort-sidebar .sort-sidebar-container .sort-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: var(--border-radius);
  transition: all 0.2s;
}
.sort-sidebar .sort-sidebar-container .sort-option:hover {
  background: var(--surface-hover);
}
.sort-sidebar .sort-sidebar-container .sort-option.active {
  background: var(--accent-subtle);
  color: var(--accent);
}
.sort-sidebar .sort-sidebar-container .sort-option.active .sort-icon {
  color: var(--accent);
}
.sort-sidebar .sort-sidebar-container .sort-option .sort-option-label {
  font-weight: var(--font-weight-semibold);
}
.sort-sidebar .sort-sidebar-container .sort-option .sort-icon {
  font-size: var(--font-size-base);
  color: var(--text-color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.responsive-table .p-button .filters-count-badge {
  background: var(--accent-hover);
  color: var(--accent-text);
  min-width: 1.375rem;
  height: 1.375rem;
  padding: 0 var(--space-1);
  font-size: var(--font-size-2xs);
  line-height: 1.375rem;
}

.responsive-table .header-right-mobile .filter-button {
  position: relative;
}
.responsive-table .header-right-mobile .filter-button .filters-count-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  margin: 0;
}

.table-scroll-frame::before, .table-scroll-frame::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: var(--space-6);
  pointer-events: none;
  z-index: 3;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.table-scroll-frame::before {
  left: 0;
  background-image: linear-gradient(to right, var(--table-scroll-shade), transparent);
}
.table-scroll-frame::after {
  right: 0;
  background-image: linear-gradient(to left, var(--table-scroll-shade), transparent);
}
.table-scroll-frame[data-overflow-start]::before, .table-scroll-frame[data-overflow-end]::after {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .table-scroll-frame::before,
  .table-scroll-frame::after {
    transition: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
